import { I18n } from '@calendly/i18n';
import { FilterMenuButton } from '@calendly/ui/components/filter-menu';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { FilterMenuTriggerIcon } from 'components/cui_filter_menu';
const filtersAppliedCss = "fd2zzba";
const FiltersApplied = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(filtersAppliedCss, props.className)} />;
});
const filterCountCss = "fe4apkm";
const FilterCount = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'h2';
  return <Component ref={ref} {...restProps} className={classNames(filterCountCss, props.className)} />;
});
const filterIconContainerCss = "feg2o49";
const FilterIconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(filterIconContainerCss, props.className)} />;
});
const triggerLabelGapCss = "t31i7d9";
const TriggerLabel = forwardRef((props, ref) => <span ref={ref} {...props} className={classNames(triggerLabelGapCss, props.className)} />);
const IconContainer = ({
  filterCount,
  isModalOpen
}) => {
  if (filterCount > 0) return null;
  if (isModalOpen) return <ArrowChevronUpMiniIcon />;
  return <ArrowChevronDownMiniIcon />;
};
export const FilterButton = forwardRef(({
  isModalOpen,
  filterCount
}, ref) => {
  const isDesktopUp = useDeviceType('isDesktopUp');
  return <FilterMenuButton ref={ref} hasSelection={filterCount > 0} aria-label={I18n.t('publisher.event_types.filter')} data-testid="meetings-filter-button" disableArrow>
      <TriggerLabel>
        <FilterIconContainer>
          <FilterMenuTriggerIcon />
        </FilterIconContainer>
        {isDesktopUp && <>
            {I18n.t('publisher.event_types.filter')}
            <IconContainer filterCount={filterCount} isModalOpen={isModalOpen} />
          </>}
        {filterCount > 0 && <FiltersApplied>
            <FilterCount>{filterCount}</FilterCount>
          </FiltersApplied>}
      </TriggerLabel>
    </FilterMenuButton>;
});

// Preserve legacy export name used by tests
FilterButton.displayName = 'FilterButton';

require("./filter_button.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filter_button.js");